import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { get, range } from 'lodash'
import Dimensions from 'react-dimensions'
import { Link } from 'react-router-dom'
import { scaleLinear } from "d3-scale"
import './index.css'
import { Origin } from 'redux-tooltip'
import { saveSvgAsPng } from 'save-svg-as-png'
import { getCsvFile } from '../../utils/csvdownload'

var d3 = require('d3')

const INCLUDED_TOPICS = [
    'SUN-CUSTSERVIND', //Customs services index
    'SUN-CLEAREFF',  //Efficency of the clearance process
    'SUN-TABTIMEIMPDOC', //Time to import:Documentary compliance
    'SUN-TABTIMEIMPBORD', //Time to import:Border compliance
    'SUN-TABCOSTIMPDOC', //Cost to import:Documentary compliance
    'SUN-TABCOSTIMPBORD', //Cost to import: Border compliance
    'SUN-TABTIMEEXPDOC', //Time to export: Documentary compliance
    'SUN-TABTIMEEXPBORD', //Time to export: Border compliance
    'SUN-TABCOSTEXPDOC', //Cost to export: Documentary compliance
    'SUN-TABCOSTEXPBORD', //Cost to export: Border compliance
    'SUN-EOSQ147', //Irregular payments in exports and imports
    'SUN-EOSQ395', //Time predictability of import procedures
    'SUN-CUSTTRANSPIND', //Customs transparency index
    ]


const Opath = Origin.wrapBy('path');

class SunBurstChart extends React.PureComponent {

  downloadPng = (e) => {
    const { countryCode } = this.props
    var node = ReactDOM.findDOMNode(this)
    const dk = node.querySelector(".download-links")
    dk.classList.add("hide")
    const donly = node.querySelector(".download-only")
    if(donly){
      donly.classList.remove("hide")
    }
    saveSvgAsPng(node, `${countryCode}-sunburst.png`, { backgroundColor: '#fff'})
    dk.classList.remove("hide")
    if (donly) {
      donly.classList.add("hide")
    }
  }


  downloadCsv =  (e) => {
    const { countryCode, includedTopics=INCLUDED_TOPICS } = this.props
    getCsvFile(`${countryCode}-thirdpillar.csv`, [countryCode], includedTopics)
  }

  render() {

    const { 
      countries,
      indicators,
      latestDataByIndicator,
      countryCode,
      baseColor='#00539B', borderColor='#0D66A5',
      emptyFraction=0.5,
      margin=40, //for labels, etc..
      includedTopics=INCLUDED_TOPICS,
      showCountryLabel=true,
      showDownloads=false,
      height=null,
      containerWidth } = this.props

    // #TODO: USE THESE?
    // const minValue = 1
    // const maxValue = 7
    const neutralColor = '#fff'

    // viewBox will be 800x800 if square

    // console.log("indicators", indicators)

    const width = 800 - ( margin * 4 )
    const chartWidth = containerWidth
    const chartHeight = height === null ? containerWidth : height
    const maxRadius = width / 2
    const minRadius = maxRadius * emptyFraction
    const delta = (maxRadius - minRadius) / 7
    const sectorAngle = Math.PI * 2 / includedTopics.length

    let scales = includedTopics.reduce((a,v,i)=>{
      // const v = `SUN-${v}`
      // const range = indicators[v].rankDirection === "1" ? [maxRadius, minRadius] : [minRadius, maxRadius]
      // a[v] = scaleLinear().range(range).domain(indicators[v].domain || [0, 7])
      const range = (indicators[v].rankDirection === 1) ? [maxRadius, minRadius + delta] : [minRadius + delta, maxRadius]
      a[v] = scaleLinear().range(range).domain(indicators[v].domain)
      return a
    }, {})

    let colorScales = includedTopics.reduce((a,v,i)=>{
      // const v = `SUN-${v}`
      // console.log("xx", v, v, indicators[v])
      // const colorRange = indicators[v].rankDirection === "1" ? [baseColor, neutralColor] : [neutralColor, baseColor]
      // a[v] = scaleLinear().range(colorRange).domain(indicators[v].domain || [0, 7])
      const colorRange = (indicators[v].rankDirection === 1) ? [baseColor, neutralColor] : [neutralColor, baseColor]
      a[v] = scaleLinear().range(colorRange).domain(indicators[v].domain)
      return a
    }, {})

    let countryData = includedTopics.reduce((a,v,i)=>{
      a[v] = {}

      a[v]['value'] = get(latestDataByIndicator[v], `[${countryCode}].v`, null)
      a[v]['year'] = get(latestDataByIndicator[v], `[${countryCode}].y`, null)
      a[v]['plotValue'] = a[v]['value'] ? scales[v](a[v]['value']) : null
      a[v]['fill'] = a[v]['value'] ? colorScales[v](a[v]['value']) : null
      return a
    }, {})

    console.log("countryData", countryData)

    const gridScale = d3.scaleLinear().range([minRadius, maxRadius]).domain([0, 7])

    return (
      <svg className="SunBurstChart__svg" viewBox={`0 0 832 ${832}`}
        style={{border:borderColor ? `solid ${borderColor} 1px` : undefined}} height={chartHeight} width={chartWidth}>
        {/* optional country label */}
        <g transform={`translate(${margin}, ${margin})`} className={`${ showCountryLabel ? '' : 'hide download-only'}`}>
          <text y={margin/2} className="SunBurstChart__country_label"><Link to={`//countries/${countryCode}`}>
          {countries[countryCode]}
          </Link></text>
        </g>
        { showDownloads && (
          <g className="download-links" transform={`translate(${margin}, ${margin})`}>
          <text y={margin/2} className="SunBurstChart__download_title">DOWNLOAD</text>
          <text y={margin/2 + 40}>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadCsv}>CSV</tspan>
            <tspan>&nbsp;&nbsp;&nbsp;</tspan>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadPng}>VIZ</tspan>
          </text>
          </g>
        )}

        {/* source label */}
        <g transform={`translate(${margin}, ${800-margin/2})`}>
          <text className="SunBurstChart__source_label">
            Source: Global Alliance for Trade Facilitation / World Economic Forum; Enabling Trade Index
          </text>
          <text className="SunBurstChart__source_label" y="24">
            The size of the rays reflects the normalized score on a 1 (worst) to 7 (best) scale
          </text>
        </g>

        <g>
          <circle className="SunBurstChart__grid" r={minRadius} cx={800/2} cy={800/2}/>
          { includedTopics.map((topic, i) => {

            // if (!countryData[topic]['plotValue']){
            //   return null
            // }

            let gridRange = range(0, 8)
              .map(v => gridScale(v))
              // .filter(v => countryData[topic]['plotValue'] && v < countryData[topic]['plotValue'])

              const gridArcs = gridRange.map((value,o) => {
              //countryData[topic]['plotValue']

              return d3.arc()
                .startAngle(function(d) { return i * sectorAngle })
                .endAngle(function(d) { return ( i + 1 ) * sectorAngle })
                .innerRadius(function(d) { return minRadius })
                .outerRadius(function(d) { return value })
            })

            const arc = d3.arc()
              .startAngle(function(d) { return i * sectorAngle })
              .endAngle(function(d) { return ( i + 1 ) * sectorAngle })
              .innerRadius(function(d) { return minRadius })
              .outerRadius(function(d) { return countryData[topic]['plotValue'] || minRadius })

            return (
                <g key={topic} transform={`translate(${800/2}, ${800/2})`}>
                <g >
                  <Opath className="SunBurstChart__sector"
                    d={arc()}
                    style={{fill:countryData[topic]['fill']}}
                    content={`${indicators[topic].shortTitle} : ${countryData[topic]['value']} (${countryData[topic]['year']})`}/>
                </g>
                <g>
                  { gridArcs.map((garc, a) => (
                    <path key={a} className="SunBurstChart__grid-2"
                      d={garc()}/>
                  )) }
                </g>
              </g>
            )
          }) }
        </g>
      </svg>
    )
  }
}


const mapStateToProps = (state, props) => ({
  countries: state.countries,
  indicators: state.indicators,
})

export default connect(mapStateToProps)(Dimensions()(SunBurstChart))



// WEBPACK FOOTER //
// ./src/components/SunBurstChart/index.js